module.exports = __webpack_public_path__ + "static/media/category5.fcee78ad.jpg";